import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IApp } from '@core/models/app.interfaces';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-previous-discussion',
  templateUrl: './previous-discussion.component.html',
  styleUrls: ['./previous-discussion.component.scss'],
  imports: [CommonModule, TranslateModule, NgbAccordionModule, FontAwesomeModule]
})
export class PreviousDiscussionComponent {
  @Input() discussions: IApp.IRegistrationDiscussion[];
  @Input() customContent: boolean;
  @Input() translationPrefix = 'REGISTRATION_PAGE.cfrPendingRegistration.';
  openPanelStates: { [key: string]: boolean } = {
    p1: false
  };

  constructor() { }

  get anyPreviousDiscussions(): boolean {
    return (this.discussions && this.discussions.filter(d => d.userComment).length > 0) || this.customContent;
  }

  get hasUnansweredComment(): boolean {
    return this.discussions && this.discussions.length > 0 && !this.discussions[0].userComment;
  }

  onPanelShown(panelId: string): void {
    this.openPanelStates[panelId] = true;
  }
  
  onPanelHidden(panelId: string): void {
    this.openPanelStates[panelId] = false;
  }

}
